import { HttpClient, HttpContext } from "@angular/common/http";
import { computed, inject, Injectable, signal } from "@angular/core";
import { fromEvent, map, merge, startWith, tap } from "rxjs";
import { ConfigService } from "../utils/config.service";
import { SKIP_GLOBAL_LOADER } from "../loader.interceptor";

@Injectable({
  providedIn: "root",
})
export class AppService {
  private _apiServer = ConfigService.settings.apiServer;

  private _http = inject(HttpClient);

  private _basexStatusUrl = `${this._apiServer.url}/datastore/write/status`;

  private _basexStatus = signal<{ blocked: boolean } | null>(null);

  readonly isBasexBlocked = computed(() => this._basexStatus()?.blocked ?? false);

  constructor() {}

  getBasexStatus() {
    const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
    return this._http
      .get<{ blocked: boolean }>(this._basexStatusUrl, { context })
      .pipe(tap((result) => this._basexStatus.set(result)));
  }

  getOnlineStatus() {
    return merge(
      fromEvent(window, "online").pipe(map(() => true)),
      fromEvent(window, "offline").pipe(map(() => false)),
    ).pipe(startWith(navigator.onLine));
  }
}
